module.exports = __webpack_public_path__ + "static/armin-van-burren-7c53bcbdd73fe83d4777573033c45dca.png";